/**
 * printer-functions.ts — Source de vérité du vocabulaire des fonctions
 * d'imprimante (impression par fonction, lots 3-4).
 *
 * Consommé par l'UI imprimantes (printers-config/printer-form) et l'UI
 * catégories (CategoryColorPickerDialog) : une seule liste, pas de
 * divergence entre les deux côtés du routage.
 *
 * Les values sont des slugs conformes aux CHECK DB identiques
 * tenant_printers_printer_function_format et categories_printer_function_format.
 */

export const PRINTER_FUNCTION_SLUG_REGEX = /^[a-z0-9_-]{1,32}$/;

export const PRINTER_FUNCTIONS = [
  { value: 'cuisine', label: 'Cuisine' },
  { value: 'bar', label: 'Bar' },
  { value: 'pizza', label: 'Pizza' },
  { value: 'grill', label: 'Grill' },
  { value: 'friture', label: 'Friture' },
  { value: 'dessert', label: 'Desserts' },
];

export const printerFunctionLabel = (f: string) =>
  PRINTER_FUNCTIONS.find((p) => p.value === f)?.label || f;
